/* BL4CKOUT: load the Gorgias chat after the visitor's first scroll, tap, key press or mouse move,
   or after a few seconds, so it does not compete with the product page while it loads.
   Settings: Theme settings -> Gorgias chat (delayed). Turn the Gorgias app embed OFF, or the chat
   loads twice; as a safety net this script does nothing if Gorgias is already on the page. */
(function () {
  var cfg = document.getElementById('apx-gorgias-config');
  if (!cfg) return;
  var src = cfg.getAttribute('data-src');
  var delay = parseInt(cfg.getAttribute('data-delay'), 10) || 4000;
  if (!src) return;
  var done = false;
  var events = ['scroll', 'pointerdown', 'keydown', 'mousemove', 'touchstart'];
  function already() {
    return !!(window.GorgiasChat || document.getElementById('gorgias-chat-widget-install-v3') ||
      document.querySelector('script[src*="config.gorgias.chat"]:not([data-apx-gorgias])'));
  }
  function load() {
    if (done) return;
    done = true;
    events.forEach(function (ev) { window.removeEventListener(ev, load, { passive: true }); });
    if (already()) return;
    var s = document.createElement('script');
    s.id = 'gorgias-chat-widget-install-v3';
    s.src = src;
    s.async = true;
    s.setAttribute('data-apx-gorgias', '');
    document.body.appendChild(s);
  }
  events.forEach(function (ev) { window.addEventListener(ev, load, { once: true, passive: true }); });
  setTimeout(load, delay);
})();
